import React, { useState } from 'react';

import './MultiSelect.scss';

interface Option {
  label: string;
  value: string;
}

interface MultiSelectProps {
  options: Option[];
  onChange: (selected: string[]) => void;
}

export const generateOptionsByCommaString = (str: string) => {
  return (str || '').split(',').map((item) => ({ label: item, value: item }));
};

const MultiSelect: React.FC<MultiSelectProps> = ({ options, onChange }) => {
  const [selected, setSelected] = useState<string[]>([]);

  const handleCheckboxChange = (value: string) => {
    const newSelected = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];
    setSelected(newSelected);
    onChange(newSelected);
  };

  return (
    <div className="multi-select">
      {options.map((option) => (
        <div className="multi-select_item" key={option.value}>
          <input
            id={`multi-select-${option.value}`}
            type="checkbox"
            value={option.value}
            checked={selected.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value)}
          />
          <label
            htmlFor={`multi-select-${option.value}`}
            className="multi-select__option"
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default MultiSelect;